import _ from 'lodash';
import {
    buildCategoryNameKey,
    buildNestedSubCategoryNameKey,
    buildSubCategoryNameKey
} from '../../../utils/translation/categories';
import {
    getCategoryUrl,
    getNestedSubCategoryUrl,
    getSubCategoryUrl
} from '../../../utils/routes';
import { sanitizeSeo } from '../utils';

import {
    GENERAL_SCHEMA,
    TYPE_BREADCRUMBS,
    TYPE_LIST_ITEM
} from '../constants';

export const formatBreadcrumbs = ({ general, pathfinderWrapper, locale, requestContext }) => {
    const {
        categoryId,
        subCategoryId,
        nestedSubCategoryId,
        gigTitle
    } = general;
    const { params } = requestContext,
        { username, slug } = params;

    const breadcrumbsItems = [
        {
            name: i18n.t(buildCategoryNameKey(categoryId), { $scope: locale }),
            url: getCategoryUrl({ general, pathfinderWrapper, absolute: true })
        }
    ];
    if (subCategoryId) {
        breadcrumbsItems.push({
            name: i18n.t(buildSubCategoryNameKey(subCategoryId), { $scope: locale }),
            url: getSubCategoryUrl({ general, pathfinderWrapper, absolute: true })
        });
    }
    if (nestedSubCategoryId && subCategoryId) {
        breadcrumbsItems.push({
            name: i18n.t(buildNestedSubCategoryNameKey(subCategoryId, nestedSubCategoryId), { $scope: locale }),
            url: getNestedSubCategoryUrl({ general, pathfinderWrapper, absolute: true })
        });
    }
    breadcrumbsItems.push({
        name: gigTitle,
        url: pathfinderWrapper.pathfinder('short_v4_user_gig',
            { username, slug },
            { absolute: true })
    });

    return sanitizeSeo({
        '@context': GENERAL_SCHEMA,
        '@type': TYPE_BREADCRUMBS,
        itemListElement: _.map(breadcrumbsItems, formatBreadcrumbItem)
    });
};

const formatBreadcrumbItem = (item, index) => ({
    '@type': TYPE_LIST_ITEM,
    position: index + 1,
    name: item.name,
    item: item.url
});
